import { Components, Theme } from "@mui/material/styles";

export const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
    styleOverrides: {
        root: {
            color: "var(--mui-palette-gray-500)",
            fontSize: "12px",
            lineHeight: "1.5",
            marginTop: "8px",
            marginLeft: "0px",
            marginRight: "0px",
            transition: "color 0.2s ease-in-out",
            "&.Mui-error": {
                color: "var(--mui-palette-red-700)",
            },
            "&.Mui-disabled": {
                color: "var(--mui-palette-gray-500)",
            },
        },
    },
};
